import type { AllarmeDinamicoDTO } from '@/models/dto/allarme/allarme-dinamico-dto'
import type { AllarmeSconosciutoDTO } from '@/models/dto/allarme/allarme-sconosciuto-dto'
import type { AllarmeStaticoDTO } from '@/models/dto/allarme/allarme-statico-dto'
import { AlarmCategory } from '@/models/types/alarm/alarm-category'
import type { DynamicAlarm } from '@/models/types/alarm/dynamic-alarm'
import type { StaticAlarm } from '@/models/types/alarm/static-alarm'
import type { UnknownAlarm } from '@/models/types/alarm/unknown-alarm'

const isDynamicAlarm = (alarm: UnknownAlarm): alarm is DynamicAlarm => {
    return alarm.category === AlarmCategory.Dynamic
}

const isAllarmeDinamico = (allarme: AllarmeSconosciutoDTO): allarme is AllarmeDinamicoDTO => {
    return allarme.category === AlarmCategory.Dynamic
}

const isStaticAlarm = (alarm: UnknownAlarm): alarm is StaticAlarm => {
    return alarm.category === AlarmCategory.Static
}

const isAllarmeStatico = (allarme: AllarmeSconosciutoDTO): allarme is AllarmeStaticoDTO => {
    return allarme.category === AlarmCategory.Static
}

export { isAllarmeDinamico, isAllarmeStatico, isDynamicAlarm, isStaticAlarm }
